<template>
  <button
    class="flex w-full items-center space-x-4 p-4 shadow"
    v-bind="$attrs"
    type="button"
    @click="open"
  >
    <IconBasket class="size-6 text-background-fg/40" />
    <div class="flex flex-1 flex-col items-start">
      <div class="text-sm font-bold">
        {{
          formatToMerchantCurrencyString(
            totalOrderItemCostPence
          )
        }}
      </div>
      <div class="text-xs text-background-fg/70">
        {{ totalQuantity }} items
      </div>
    </div>

    <div class="w-1/2">
      <ActionButtonPrimary class="w-full">
        View Order
      </ActionButtonPrimary>
    </div>
  </button>

  <ShoppingCartDrawerCurrentOrder :is-open="isOpen" />
</template>

<script lang="ts">
export default {
  inheritAttrs: false,
}
</script>

<script setup lang="ts">
const { formatToMerchantCurrencyString } = useCurrency()
const { totalOrderItemCostPence, totalQuantity } =
  useCurrentOrder()
const { isOpen, open } = useShoppingCartDrawer()
</script>
